import {HttpInterceptorFn} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { inject } from '@angular/core';


export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const translate = inject(TranslateService);
    if (!req.url.includes('/api/v1/')) {
        return next(req);
    }

    return next(req)
        .pipe(
            catchError((error) => {
                if (error.status >= 500) {
                    const message = translate.instant('ERRORS.server_error');
                    alert(message);
                }
                return throwError(() => error);
            })
        );
};
